<template>
  <div
    class="m-image-container"
    :class="{
      watermark
    }"
    :style="{
      'paddingBottom': `${ratio * 100}%`
    }"
  >
    <slot>
      <img
        :src="src"
        :alt="alt"
      >
    </slot>
  </div>
</template>

<script>
export default {
  name: 'ImageContainer',
  props: {
    // height:width 比, 默认为 0, 表示自动
    ratio: {
      type: Number,
      default: 0
    },
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    watermark: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.m-image-container {
  position: relative;
  overflow: hidden;
  background: #666;

  & > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  &.watermark {
    background: url("~wap/common/images/theme-bg-watermark.png") no-repeat center;
    background-size: 100% 100%;
  }
}

[data-mode="light"] .m-image-container {
  &.watermark {
    background: url("~wap/common/images/theme-bg-watermark[light-default].png") no-repeat center;
    background-size: 100% 100%;
  }
}
</style>
